export type HelpCategory = 'water_detected' | 'freeze_loss' | 'low_temp' | 'freezer' | 'refrigeration' | 'high_ambient_temp' | 'none'
export const getHelpCategory = (ruleName: string): HelpCategory => {
  let helpCategory: HelpCategory = 'none'
  const lowerCasedName = ruleName.toLowerCase()
  if (lowerCasedName.includes('water detected')) helpCategory = 'water_detected'
  else if (lowerCasedName.includes('freeze loss')) helpCategory = 'freeze_loss'
  else if (lowerCasedName.includes('low temperature') || lowerCasedName.includes('temperature alert')) helpCategory = 'low_temp'
  else if (lowerCasedName.includes('freezer')) helpCategory = 'freezer'
  else if (lowerCasedName.includes('refrigeration')) helpCategory = 'refrigeration'
  else if (lowerCasedName.includes('high ambient temperature')) helpCategory = 'high_ambient_temp'
  return helpCategory
}

export const helpContent = {
  water_detected: [
    'Check the location immediately.',
    'Use towels to soak up any water.',
    'Turn off the water supply to stop the leak if necessary.',
    'Reach out to a plumber or property management for help.',
  ],
  freeze_loss: ['Check the location immediately.', 'Confirm heating system is running', 'Check thermostat is set to 55°F / 13°C or higher.'],
  low_temp: ['Check the location', 'Confirm heating system is running', 'Check thermostat is set to 55°F / 13°C or higher.'],
  freezer: [
    'Check the location immediately.',
    'Ensure the door is closing properly.',
    'Verify door seals are intact and unobstructed.',
    'Confirm the evaporator is clean.',
    'Verify refrigerant levels',
    'Contact service provider if needed.',
  ],
  refrigeration: [
    'Ensure the door is closing properly',
    'Verify door seals are intact. Ice or dirt buildup may hinder closing.',
    'Confirm the evaporator is clean.',
    'Verify refrigerant levels',
    'Contact service provider if needed.',
  ],
  high_ambient_temp: [
    'Check the location immediately.',
    'Ventilate the room to keep it cool.',
    'Use fans or air conditioning for better airflow.',
    'Remove sensitive electronics, combustible liquids, or aerosols at risk of damage due to high temps.',
  ],
  none: [],
}
